<template>
  <div
    v-if="data"
    class="item"
    @click="clickDetail(data)"
  >
    <div class="top">
      <!-- code -->
      <span
        v-if="data.code && data.code.code"
        class="code"
      ><i class="iconfont iconicon-test30 fs-gray" />{{ data.code.code }}</span>
      <div class="right">
        <!-- 等级 -->
        <div class="level">
          <cube-rate
            v-if="data.base_info_info_level && data.base_info_info_level.type === 2"
            v-model="data.base_info_info_level.info_level.fieldvalue"
            :disabled="true"
            :max="data.base_info_info_level.level"
          />
          <span
            v-else
            class="level2"
          >{{ info_level2 }}</span>
        </div>
        <!-- 状态 -->
        <span
          v-if="status && status.value"
          :style="{ 'background-color': status.color }"
          class="status"
        >{{ status.value }}</span>
      </div>
    </div>
    <!-- 其他字段处理后的列表 -->
    <ul class="sort-rows">
      <template v-for="item in datasList">
        <li
          :key="item.fieldkey"
          class="one"
        >
          <span class="label">{{ item.title }}：</span>
          <span
            v-if="item.fieldkey === 'contact_info'"
            class="val textOverflow"
          >{{ item.contact_name.fieldvalue || '- -' }}</span>
          <span
            v-else-if="item.fieldkey === 'from_info'"
            class="val textOverflow"
          >{{ item.from.fieldvalue }} <i v-if="item.from.fieldvalue && item.from_detail.fieldvalue">|</i> {{ item.from_detail.fieldvalue }}</span>
          <span
            v-else-if="item.fieldkey === 'dev_userid'"
          >
            <i
              v-if="item.dev_truename"
              :class="['is-read', { 'no': !item.dev_isread, 'yes': item.dev_isread }]"
            />
            <i class="truename">{{ item.dev_truename || '- -' }}</i>
          </span>
          <span
            v-else-if="item.fieldkey === 'follow_userid'"
            :class="{ 'fs-error': item.color_type === 1, 'fs-gray': item.color_type === 2 }"
          >
            <i
              v-if="item.follow_truename"
              :class="['is-read', { 'no': !item.follow_isread, 'yes': item.follow_isread }]"
            />
            <i v-if="item.follow_type === 1">[{{ $t('message["394"]') }}]</i>
            <i v-else-if="item.follow_type === 2">[{{ $t('message["139"]') }}]</i>
            <i v-else-if="item.follow_type === 3">[{{ $t('message["146"]') }}]</i>
            <i v-else-if="item.follow_type === 5">[{{ $t('message["1460"]') }}]</i>
            <i
              v-else
              class="truename"
            >{{ item.follow_truename || '- -' }}</i>
          </span>
          <span v-else-if="item.fieldkey === 'last_followup_time'">{{ item.last_followup_time ||'- -' }}</span>
          <span v-else-if="item.fieldkey === 'next_followup_time'">{{ item.next_followup_time || '- -' }}</span>
          <span v-else-if="item.fieldkey === 'followup_remind_time'">{{ item.last_followup_time || '- -' }}</span>
          <!-- 信息类型 -->
          <span
            v-else-if="item.fieldkey === 'base_info_info_type'"
          >
            <span class="info-type">{{ item['info_type'].fieldvalue || '- -' }}</span>
            <span
              v-if="item && item['info_sign'] && item['info_sign'].fieldvalue"
              class="beian-tag"
            >{{ item['info_sign'].fieldvalue }}</span>
          </span>
          <span
            v-else
            class="val textOverflow"
          >{{ item.fieldvalue || '- -' }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    'data': {
      type: Object,
      default: () => { }
    },
    statusKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    status () {
      if (!this.data) return
      let data = {}
      switch (this.statusKey) {
        // case 'base_info_info_status':
        //   data.value = this.data['base_info_info_status'].fieldvalue
        //   break
        case 'audit_status':
          data.value = this.data['audit_status']
          break
      }
      switch (data.value) {
        case this.$t('message["1206"]'):
          data.color = '#42C27E'
          break
        case this.$t('message["143"]'):
          data.color = '#F6A953'
          break
        case this.$t('message["542"]'):
          data.color = '#F57676'
          break
      }

      return data
    },
    info_level2 () {
      let newVal = ''
      const { base_info_info_level: info = {} } = this.data
      const { info_level: infoLevel = {} } = info
      const { fieldvalue = 0 } = infoLevel
      const arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      arr.forEach((item, index) => {
        if (fieldvalue - 1 === index) {
          newVal = `[${item}]` || ''
        }
      })
      return newVal
    },
    datasList () {
      let { data = {} } = this
      let { list = {} } = data
      const len = Object.keys(list).length
      let obj = {}
      if (len > 5) {
        for (let i = 0; i < 5; i++) {
          obj = Object.assign(obj, { [Object.keys(list)[i]]: Object.values(list)[i] })
        }
      } else {
        obj = list
      }
      return obj
    }
  },
  methods: {
    clickDetail (data) {
      this.$emit('handleDetail', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  width: 350px;
  margin: 12px;
  padding: 8px 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(229, 229, 229, 1);
  .top {
    display: flex;
    justify-content: space-between;
    padding: 12px;
  }
  .code {
    align-self: center;
    font-size: 16px;
    font-weight: bold;
    .iconfont {
      margin-right: 8px;
      font-size: 14px;
      color: #d6d6d6;
    }
  }
  .right {
    display: flex;
  }
  .level::v-deep {
    margin: 0 8px;
    .cube-rate {
      // width: 120px;
      vertical-align: middle;
    }
    .cube-rate-item {
      width: 14px;
      margin-right: 2px;
    }
  }
  .status {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    padding: 0 8px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    background-color: $danger-color;
  }
  .info-type {
    display: inline-block;
    word-break: break-all;
  }
  .beian-tag {
    display: inline-block;
    height: 20px;
    line-height: 18px;
    margin-left: 4px;
    margin-top: -1px;
    font-size: 12px;
    color: #666;
    padding: 0 7px;
    border: solid 1px #EBEBEB;
    border-radius: 4px;
  }
  .one {
    display: flex;
    line-height: 24px;
    padding: 8px 12px;
    font-size: 14px;
    .label {
      display: inline-block;
      min-width: 80px;
      text-align: left;
    }
    i {
      font-style: normal;
    }
    .is-read {
      display: inline-block;
      position: relative;
      font-size: 0;
      transform: scale(0.5);
      transform-origin: center left;
      &.no {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        border-radius: 8px;
        background: #4CA0F2;
      }
      &.yes {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        border-radius: 8px;
        background: #D6D6D6;
      }
    }
    .is-read + .truename {
      margin-left: -4px;
      vertical-align: middle;
    }
  }
}
</style>
